import React, { useState, useEffect, useRef } from "react";
import emailjs from "@emailjs/browser";
import AOS from "aos";
import "aos/dist/aos.css";
import ReCAPTCHA from "react-google-recaptcha";

const SERVICE_ID = "service_5pnerir";
const TEMPLATE_ID = "template_mesv18f";
const PUBLIC_KEY = "U5WsPa3AzTs-YMmCq";

// ✅ Clé TEST Google (localhost)
const RECAPTCHA_SITE_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";


const DevisFormFull = () => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    nomEntreprise: "",
    statut: "",
    prenom: "",
    nom: "",
    adresse: "",
    codePostal: "",
    pays: "Maroc",
    ville: "",
    mobile: "",
    tel: "",
    fax: "",
    email: "",
    message: "",
    
  });

  
  const [sending, setSending] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);

  /* ✅ Regex VALIDATION */
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const phoneRegex = /^(?:\+212|0)([5-7]\d{8})$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    /* ✅ VALIDATIONS */
    if (!emailRegex.test(formData.email)) {
      alert("❌ Email invalide.");
      return;
    }

    if (!phoneRegex.test(formData.mobile)) {
      alert("❌ Numéro mobile invalide (Maroc).");
      return;
    }

    if (!captchaValue) {
      alert("❌ Veuillez confirmer que vous n'êtes pas un robot.");
      return;
    }

    setSending(true);

    try {
      await emailjs.sendForm(
        SERVICE_ID,
        TEMPLATE_ID,
        formRef.current,
        PUBLIC_KEY
      );

      alert("✅ Demande de devis envoyée avec succès !");
      setFormData({
        nomEntreprise: "",
        statut: "",
        prenom: "",
        nom: "",
        adresse: "",
        codePostal: "",
        pays: "Maroc",
        ville: "",
        mobile: "",
        tel: "",
        fax: "",
        email: "",
        message: "",
        
      });
      setCaptchaValue(null);
    } catch (error) {
  console.error("Erreur EmailJS FULL :", error);
  alert("❌ " + (error.text || error.message || "Erreur inconnue"));
}


    setSending(false);
  };

  useEffect(() => {
    AOS.init({ duration: 1500, once: true });
  }, []);

  return (
    <section className="devis-section-full container">
      <div className="devis-container-full" data-aos="zoom-in">
        <h2>Demande de devis</h2>

        <form ref={formRef}  className="devis-form-full container" onSubmit={handleSubmit}>
          <input type="hidden" name="time" value={new Date().toLocaleString()} />

          <div className="row">
            <select name="statut" value={formData.statut} onChange={handleChange} placeholder="Statut professionnel*" required>
              <option value="" disabled selected>Statut professionnel*</option>
              <option value="Particulier">Particulier</option> 
              <option value="Revendeur">Revendeur</option> 
              <option value="Chef de projet">Chef de projet</option> 
              <option value="Autre">Autre</option> 
            </select>
            <input name="nomEntreprise" placeholder="Nom de l'entreprise*" value={formData.nomEntreprise} onChange={handleChange} required />
          </div>
          <div className="row">
            <input name="prenom" placeholder="Prénom*" value={formData.prenom} onChange={handleChange} required />
            <input name="nom" placeholder="Nom*" value={formData.nom} onChange={handleChange} required />
          </div>

          <div className="row">
            <input name="adresse" placeholder="Adresse" value={formData.adresse} onChange={handleChange} />
            <input name="codePostal" placeholder="Code postal" value={formData.codePostal} onChange={handleChange} />
          </div>

          <div className="row">
            <select name="pays" value={formData.pays} onChange={handleChange}>
              <option value="Afghanistan">Afghanistan</option> 
              <option value="Afrique du Sud">Afrique du Sud</option> 
              <option value="Albanie">Albanie</option> 
              <option value="Algérie">Algérie</option> 
              <option value="Allemagne">Allemagne</option> 
              <option value="Andorre">Andorre</option> 
              <option value="Angola">Angola</option> 
              <option value="Arabie Saoudite">Arabie Saoudite</option> 
              <option value="Argentine">Argentine</option> 
              <option value="Arménie">Arménie</option> 
              <option value="Australie">Australie</option> 
              <option value="Autriche">Autriche</option> 
              <option value="Azerbaïdjan">Azerbaïdjan</option>

              <option value="Bahamas">Bahamas</option> <option value="Bahreïn">Bahreïn</option> <option value="Bangladesh">Bangladesh</option> <option value="Belgique">Belgique</option> <option value="Belize">Belize</option> <option value="Bénin">Bénin</option> <option value="Bhoutan">Bhoutan</option> <option value="Biélorussie">Biélorussie</option> <option value="Bolivie">Bolivie</option> <option value="Bosnie-Herzégovine">Bosnie-Herzégovine</option> <option value="Botswana">Botswana</option> <option value="Brésil">Brésil</option> <option value="Brunei">Brunei</option> <option value="Bulgarie">Bulgarie</option> <option value="Burkina Faso">Burkina Faso</option> <option value="Burundi">Burundi</option>

              <option value="Cambodge">Cambodge</option> <option value="Cameroun">Cameroun</option> <option value="Canada">Canada</option> <option value="Cap-Vert">Cap-Vert</option> <option value="Chili">Chili</option> <option value="Chine">Chine</option> <option value="Chypre">Chypre</option> <option value="Colombie">Colombie</option> <option value="Comores">Comores</option> <option value="Congo">Congo</option> <option value="Corée du Nord">Corée du Nord</option> <option value="Corée du Sud">Corée du Sud</option> <option value="Costa Rica">Costa Rica</option> <option value="Côte d'Ivoire">Côte d'Ivoire</option> <option value="Croatie">Croatie</option> <option value="Cuba">Cuba</option>

              <option value="Danemark">Danemark</option> <option value="Djibouti">Djibouti</option> <option value="Dominique">Dominique</option>

              <option value="Égypte">Égypte</option> <option value="Émirats arabes unis">Émirats arabes unis</option> <option value="Équateur">Équateur</option> <option value="Érythrée">Érythrée</option> <option value="Espagne">Espagne</option> <option value="Estonie">Estonie</option> <option value="Eswatini">Eswatini</option> <option value="États-Unis">États-Unis</option> <option value="Éthiopie">Éthiopie</option>

              <option value="Fidji">Fidji</option> <option value="Finlande">Finlande</option> <option value="France">France</option>

              <option value="Gabon">Gabon</option> <option value="Gambie">Gambie</option> <option value="Géorgie">Géorgie</option> <option value="Ghana">Ghana</option> <option value="Grèce">Grèce</option> <option value="Grenade">Grenade</option> <option value="Guatemala">Guatemala</option> <option value="Guinée">Guinée</option> <option value="Guinée-Bissau">Guinée-Bissau</option> <option value="Guinée équatoriale">Guinée équatoriale</option>

              <option value="Haïti">Haïti</option> <option value="Honduras">Honduras</option> <option value="Hongrie">Hongrie</option> <option value="Inde">Inde</option> <option value="Indonésie">Indonésie</option> <option value="Irak">Irak</option> <option value="Iran">Iran</option> <option value="Irlande">Irlande</option> <option value="Islande">Islande</option> <option value="Israël">Israël</option> <option value="Italie">Italie</option>

              <option value="Jamaïque">Jamaïque</option> <option value="Japon">Japon</option> <option value="Jordanie">Jordanie</option> <option value="Kazakhstan">Kazakhstan</option> <option value="Kenya">Kenya</option> <option value="Kirghizistan">Kirghizistan</option> <option value="Kiribati">Kiribati</option> <option value="Koweït">Koweït</option> <option value="Laos">Laos</option> <option value="Lesotho">Lesotho</option> <option value="Lettonie">Lettonie</option> <option value="Liban">Liban</option> <option value="Liberia">Liberia</option> <option value="Libye">Libye</option> <option value="Liechtenstein">Liechtenstein</option> <option value="Lituanie">Lituanie</option> <option value="Luxembourg">Luxembourg</option>

              <option value="Madagascar">Madagascar</option> <option value="Malaisie">Malaisie</option> <option value="Malawi">Malawi</option> <option value="Maldives">Maldives</option> <option value="Mali">Mali</option> <option value="Malte">Malte</option> <option value="Maroc" selected>Maroc</option> <option value="Maurice">Maurice</option> <option value="Mauritanie">Mauritanie</option> <option value="Mexique">Mexique</option> <option value="Moldavie">Moldavie</option> <option value="Monaco">Monaco</option> <option value="Mongolie">Mongolie</option> <option value="Monténégro">Monténégro</option> <option value="Mozambique">Mozambique</option> <option value="Namibie">Namibie</option> <option value="Népal">Népal</option> <option value="Nicaragua">Nicaragua</option> <option value="Niger">Niger</option> <option value="Nigéria">Nigéria</option> <option value="Norvège">Norvège</option> <option value="Nouvelle-Zélande">Nouvelle-Zélande</option>

              <option value="Oman">Oman</option> <option value="Ouganda">Ouganda</option> <option value="Ouzbékistan">Ouzbékistan</option> <option value="Pakistan">Pakistan</option> <option value="Panama">Panama</option> <option value="Papouasie-Nouvelle-Guinée">Papouasie-Nouvelle-Guinée</option> <option value="Paraguay">Paraguay</option> <option value="Pays-Bas">Pays-Bas</option> <option value="Pérou">Pérou</option> <option value="Philippines">Philippines</option> <option value="Pologne">Pologne</option> <option value="Portugal">Portugal</option> <option value="Qatar">Qatar</option> <option value="Roumanie">Roumanie</option> <option value="Royaume-Uni">Royaume-Uni</option> <option value="Russie">Russie</option> <option value="Rwanda">Rwanda</option>

              <option value="Salvador">Salvador</option> <option value="Sénégal">Sénégal</option> <option value="Serbie">Serbie</option> <option value="Seychelles">Seychelles</option> <option value="Sierra Leone">Sierra Leone</option> <option value="Singapour">Singapour</option> <option value="Slovaquie">Slovaquie</option> <option value="Slovénie">Slovénie</option> <option value="Somalie">Somalie</option> <option value="Soudan">Soudan</option> <option value="Soudan du Sud">Soudan du Sud</option> <option value="Sri Lanka">Sri Lanka</option> <option value="Suède">Suède</option> <option value="Suisse">Suisse</option> <option value="Tadjikistan">Tadjikistan</option> <option value="Tanzanie">Tanzanie</option> <option value="Tchad">Tchad</option> <option value="Thaïlande">Thaïlande</option> <option value="Togo">Togo</option> <option value="Tunisie">Tunisie</option> <option value="Turkménistan">Turkménistan</option> <option value="Turquie">Turquie</option> <option value="Ukraine">Ukraine</option> <option value="Uruguay">Uruguay</option> <option value="Vanuatu">Vanuatu</option> <option value="Venezuela">Venezuela</option> <option value="Vietnam">Vietnam</option> <option value="Yémen">Yémen</option> <option value="Zambie">Zambie</option> <option value="Zimbabwe">Zimbabwe</option>


            </select>
            <input name="ville" placeholder="Ville" value={formData.ville} onChange={handleChange} />
          </div>

          <div className="row">
            <input
              name="mobile"
              placeholder="Mobile* (+212 ou 0...)"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
            <input name="tel" placeholder="Tel" value={formData.tel} onChange={handleChange} />
          </div>

          <div className="row">
            <input name="fax" placeholder="Fax" value={formData.fax} onChange={handleChange} />
            <input type="email" name="email" placeholder="Email*" value={formData.email} onChange={handleChange} required />
          </div>
          
           

          <textarea
            className="row"
            name="message"
            placeholder="Message*"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          />

          {/* ✅ reCAPTCHA */}
          <div style={{ margin: "15px 0" }}>
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              onChange={(value) => setCaptchaValue(value)}
            />
          </div>

          {/* ✅ Bouton pro */}
          <button type="submit" disabled={sending}>
            {sending ? "⏳ Envoi en cours..." : "Envoyer"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default DevisFormFull;
